import { useEffect, useState } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase";

export const useNotesLog = (pathCrumbs, mapper) => {
  const [notesLog, setNotesLog] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, ...pathCrumbs), orderBy("createdAt", "asc"))
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => mapper(doc));
      setNotesLog(docs);
    }
  }, [value, mapper]);

  return { notesLog, loading, error };
};
